/**
 * Humanize taxonomy labels for Object / Layers (person → Person).
 * @param {string|null|undefined} raw
 * @param {string} [fallback="Object"]
 * @param {number} [maxLen=28]
 */
export function formatClassifyLabel(raw, fallback = "Object", maxLen = 28) {
  let s = String(raw || "")
    .trim()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ");
  if (!s) return fallback;
  s = s
    .split(" ")
    .map((p) => (p ? p.charAt(0).toUpperCase() + p.slice(1).toLowerCase() : ""))
    .join(" ");
  if (s.length > maxLen) {
    s = `${s.slice(0, maxLen - 1).trimEnd()}…`;
  }
  return s;
}
